import React from "react";
import { Table } from "@redriver/cinnamon";
import { withPermissions } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import EditClientAuthorisedSignatory from "./EditClientAuthorisedSignatory";
import DeleteClientAuthorisedSignatory from "./DeleteClientAuthorisedSignatory";
import { SignatoryState as CustomerSignatoryState } from "features/../../../shared/constants/enums";

const ClientAuthorisedSignatoryActions = ({
  item,
  onRefresh,
  hasPermission,
}) => {
  const canEdit =
    hasPermission(Targets.Client, Actions.Edit) &&
    item.state != CustomerSignatoryState.Authorised;
  const canDelete = hasPermission(Targets.Client, Actions.Delete);

  if (!canEdit && !canDelete) return null;

  return (
    <Table.Menu openOnHover>
      {canEdit && (
        <EditClientAuthorisedSignatory
          item={item}
          onUpdated={onRefresh}
          as={Table.MenuItem}
        >
          Edit
        </EditClientAuthorisedSignatory>
      )}
      {canDelete && (
        <DeleteClientAuthorisedSignatory
          item={item}
          onDeleted={onRefresh}
          as={Table.MenuItem}
        >
          Delete
        </DeleteClientAuthorisedSignatory>
      )}
    </Table.Menu>
  );
};

export default withPermissions(ClientAuthorisedSignatoryActions);
